import { application } from "./application"

import ThemeController from "./theme_controller"
import ClipboardController from "./clipboard_controller"
import TocController from "./toc_controller"
import MarkdownEditorController from "./markdown_editor_controller"
import MarkdownToolbarController from "./markdown_toolbar_controller"
import SlugController from "./slug_controller"
import ImageUploadController from "./image_upload_controller"
import LanguageTabsController from "./language_tabs_controller"
import SidebarController from "./sidebar_controller"

application.register("theme", ThemeController)
application.register("clipboard", ClipboardController)
application.register("toc", TocController)
application.register("markdown-editor", MarkdownEditorController)
application.register("markdown-toolbar", MarkdownToolbarController)
application.register("slug", SlugController)
application.register("image-upload", ImageUploadController)
application.register("language-tabs", LanguageTabsController)
application.register("sidebar", SidebarController)
